/**
 * Factory function that provides object with a clean interface to handle to form state.
 */
function sectionState(max) {
  let current_item = 0;
  let callbacks = [];
  let on_disable = [];
  let on_enable = [];
  let is_disabled = false;

  return {
    // go to the next form section
    next() {
      let prev = current_item;

      if (current_item < max) {
        current_item++;
      }

      callbacks.forEach(callback => callback(current_item, prev));
    },

    // add callback to run on current_item/section change
    onChange(callback) {
      callbacks.push(callback);
    },

    // add callbacks to run on starting disabled state
    onDisable(callback) {
      on_disable.push(callback);
    },

    // add callback to run on state being enabled
    onEnable(callback) {
      on_enable.push(callback);
    },

    // go to given section and run callbacks added by onChange
    goto(item) {
      let prev = current_item;
      current_item = item;
      callbacks.forEach(callback => callback(current_item, prev));
    },

    // change state to disabled
    disable() {
      is_disabled = true;
      on_disable.forEach(callback => callback(current_item));
    },

    // change state to enabled
    enable() {
      is_disabled = false;
      on_enable.forEach(callback => callback(current_item));
    },

    // return true if the state is disabled
    checkDisabled() {
      return is_disabled;
    },

    // check current section
    checkCurrent() {
      return current_item;
    }
  };
};

export default sectionState;
